// js和APP对调工具方法
// iOS  HQKJJSBridgeiOSFunction 公共方法 type类型
// 调用格式
// let data = {
//   type:0,
//   title:'描述',
//   data:{
//     key: value,
//   }
// }
// window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage(data)
// type类型
// 0 token过期
// 1 设置标题
// 101 编辑问题
// 102 返回首页
// 103设置顶部题数和总题数
// 104 返回指定页面
// 105 ios分享
// 106 返回题库首页
// 200 保利视频播放

class AppSdk {
    // try {
  //   switch (this.terminalType) {
  //     case 'iOS':
  //       (() => {
  //         // 暂无
  //       })()
  //       break
  //     case 'Android':
  //       (() => {
  //         window.tikuWebview.setRefresh(status)
  //       })()
  //       break
  //   }
  // } catch (e) {
  //   console.log(e, '控制下拉刷新')
  // }
    constructor () {
      // 判断设备终端
      const u = window.navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // 安卓
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || /(iPhone|iPad|iPod|iOS|Macintosh)/i.test(u) // ios
      this.terminalType = isAndroid ? 'Android' : isIOS ? 'iOS' : 'PC'
      this.setAndroidFontSize()
    }
    setRefresh (status) {
      // 题库首页下拉刷新
      // status true 为可以刷新 否则为 不能刷新
      try {
        switch (this.terminalType) {
          case 'iOS':
            (() => {
              // 暂无
            })()
            break
          case 'Android':
            (() => {
              window.tikuWebview.setRefresh(status)
            })()
            break
        }
      } catch (e) {
        console.log(e, '控制下拉刷新')
      }
    }
    setWebviewTitle (obj) {
      // 设置title
      let resObj = {
        'title': obj.title ? obj.title.substring(0, 12) : ''
      }
      setTimeout(() => {
        try {
          // 延迟一下 否则无效
          switch (this.terminalType) {
            case 'iOS':
              (() => {
                resObj.zkTitle = resObj.title
                window.webkit.messageHandlers.iOS_ResponseOfReloadTitleEvent.postMessage(resObj)
              })()
              break
            case 'Android':
              (() => {
                window.tikuWebview.setWebviewInfo(JSON.stringify(resObj))
              })()
              break
          }
        } catch (e) {
          document.title = resObj.title
          console.log(e, '设置标题')
        }
      }, 200)
    }
    setBackPage (obj) {
      console.log(obj)
      // obj = {
      //   describe: '事件描述文案',
      //   type: '返回的类型 1 指定页面 2 返回主页',
      //   url: '返回的url 如果返回主页则不传'
      // }
      // app左上角返回按钮控制
      try {
        switch (this.terminalType) {
          case 'iOS':
            (() => {
              // 注: ios 重新定义一下
              console.log(obj)
              if (obj.type === 1) {
                // 旧方法只支持返回指定页面
                window.webkit.messageHandlers.iOS_ResponseOfGoBackEvent.postMessage(obj)
              } else {
                // 只支持返回主页
                window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage({
                  type: 102,
                  describe: obj.describe,
                  data: {}
                })
              }
            })()
            break
          case 'Android':
            (() => {
              console.log('安卓')
              window.tikuWebview.back(JSON.stringify(obj))
            })()
            break
        }
      } catch (e) {
        console.log(e, 'app左上角返回按钮控制')
      }
    }
    setJsBackPage (obj) {
      // 该方法待调试
      // js控制返回 比如说点击页面上的按钮返回
      // obj = {
      //   describe: '事件描述文案',
      //   type: '返回的类型 1 指定页面 2 返回主页',
      //   url: '返回的url 如果返回主页则不传'
      // }
      try {
        switch (this.terminalType) {
          case 'iOS':
            (() => {
              alert('ios 不支持 请按返回键返回')
            })()
            break
          case 'Android':
            (() => {
              window.tikuWebview.goBack(JSON.stringify(obj))
            })()
            break
        }
      } catch (e) {
        console.log(e, 'js控制返回')
      }
    }
    setUesrAskQuestions (obj) {
      // 用户提问
      let flay = false
      const name = window.Vm.$hmTool.removeHtmlTag(obj.data.name, [])
      obj.data.name = name
      let getCookie = function (name) {
        var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
        if (arr != null) {
          return arr[2]
        } else {
          return ''
        }
      }
      try {
        switch (this.terminalType) {
          case 'iOS':
            (() => {
              // 暂无
              const iosObj = {
                type: 101,
                describe: obj.describe,
                data: obj.data
              }
              console.log(getCookie('styleType'), '类型的统计')
              if (window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage) {
                flay = true
              }
              let getStyleType = getCookie('styleType')
              if (getStyleType === 'kuaiji') {
                // 兼容新版本的恒企会计
                window.webkit.messageHandlers.HQJSiOSGetVersionCode.postMessage(JSON.stringify({data: 'versionQuestionBank'}))
                let versionFun = new Promise((resolve, reject) => {
                  window.versionQuestionBank = function (productID) {
                    resolve(productID)
                  }
                })
                versionFun.then(function (version) {
                  let versionNum = Number(version.replace(/\./g, ''))
                  if (versionNum < 500) {
                    // 旧版本方法
                    window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage(iosObj)
                  } else {
                    // 新版本的方法
                    const iosObj = {
                      type: 103,
                      describe: obj.describe,
                      data: obj.data
                    }
                    obj.data.tk_course_no = getCookie('courseId')
                    window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage(iosObj)
                  }
                })
              } else {
                // 自考和牵引力拿旧版本
                window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage(iosObj)
              }
            })()
            break
          case 'Android':
            (() => {
              let subjectId = obj.data.subjectId
              let subjectName = obj.data.name
              let courseId = getCookie('courseId')
              if (window.tikuWebview.toAsk) {
                flay = true
              }
              if (window.tikuWebview.toPrompt) {
                let andData = {
                  path: 'tiku/ask',
                  data: {
                    tk_id: subjectId,
                    content: subjectName,
                    tk_comId: '1',
                    tk_kindId: '1',
                    tk_chapterId: '1',
                    remark: obj.describe,
                    tk_course_no: courseId
                  }
                }
                window.tikuWebview.toPrompt(JSON.stringify(andData))
              } else {
                // 旧版本兼容
                window.tikuWebview.toAsk(subjectId, subjectName, '1', '1', '1', obj.describe)
              }
            })()
            break
        }
      } catch (e) {
        console.log(e, '用户提问')
      }
      return flay
    }
    setPlayVideo (obj) {
      console.log(obj, '观看视频')
      let flay = false
      try {
        switch (this.terminalType) {
          case 'iOS':
            (() => {
              if (window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage) {
                flay = true
              }
              const iosObj = {
                title: obj.describe,
                type: 200,
                data: {
                  playTitle: obj.data.name,
                  playID: obj.data.id
                }
              }
              window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage(iosObj)
            })()
            break
          case 'Android':
            (() => {
              let setObj = {
                polyvVid: obj.data.id,
                playName: obj.data.name
              }
              if (window.tikuWebview.toRecord) {
                flay = true
              }
              window.tikuWebview.toRecord(JSON.stringify(setObj))
            })()
            break
        }
      } catch (e) {
        console.log(e, '观看视频')
      }
      return flay
    }
    setRightPopupData (arr) {
      // 调起右上角列表
      // 当前使用的类型 2: 纠错 3 分享
      // 例: 每个事件都传递对应的对象和type
      // [
      //   {
      //     // 要展示的标题
      //     "title": "纠错",
      //     // 标题傍边的icon url
      //     "titleIcon": "http://download.hqjy.com/file/tiku_jiucuo.png",
      //     // 类型
      //     "type": 2,
      //     // 跳转页面的url
      //     "jumpUrl": "",
      //     // 描述
      //     "describe": "调用纠错交互"
      //   }
      // ]
      try {
        switch (this.terminalType) {
          case 'iOS':
            (() => {
              window.webkit.messageHandlers.iOS_TikuPopupData.postMessage(arr)
            })()
            break
          case 'Android':
            (() => {
              window.tikuWebview.tikuPopupData(JSON.stringify(arr))
            })()
            break
        }
      } catch (e) {
        console.log(e, '调起右上角列表')
      }
    }
    setShareConfig (data) {
      // 调起手机右上角分享
      console.log(data, '分享')
      if (this.terminalType === 'iOS') {
        try {
          window.webkit.messageHandlers.setShareConfig.postMessage(JSON.stringify(data))
        } catch (e) {
          console.log(e)
        }
      } else if (this.terminalType === 'Android') {
        try {
          window.webview.setShareConfig(JSON.stringify(data))
        } catch (e) {
          console.log(e)
        }
      } else {
        // pc
      }
    }
    setAndroidFontSize () {
      /* eslint-disable */
      // 设置安卓部分机型系统字体放大 影响H5'
      if (this.terminalType !== 'Android') return
      var html = document.querySelector('html')
      var fontSize = window.getComputedStyle(html,null).getPropertyValue('font-size') // 实际的大小字体
      var fontSize2 = html.style.fontSize // 设定的大小
      var result1= fontSize.match(/\d+/)[0];
      var result2=fontSize2.match(/\d+/)[0];
      var newFontSize = 0
      // 放大的情况  result1 大  result2 小
      // 缩小的情况 result1 小  result2 大
  
      // 正常情况直接返回
      if(result1 === result2) return
      window.addEventListener("DOMContentLoaded",function () {
        setTimeout(function () {
          if (result1< result2) {
            // 缩小字体
            newFontSize = result2
          } else {
            newFontSize = (result2 * result2 / result1).toFixed(0)
          }
          html.style.fontSize = newFontSize +'px'
        }, 500)
      });
    }
    appChildPage () {
      return 'app&history.aspx'
    }
    isIPhoneX() {
      if (this.terminalType === 'iOS') {
        //iphoneX
        if (screen.height == 812 && screen.width == 375)return true
        //iphone Xs Max
        if (screen.width == 414 && screen.height == 896 )return true
        return false
      }
      return false
    }
    getAppType () {
      // 0会计，1自考，2讲师，20牵引力
      const describe = '0会计，1自考，2讲师，20牵引力'
      return new Promise((resolve, reject)=>{
        try {
          switch (this.terminalType) {
            case 'iOS':
              (() => {
                if (!window.webkit.messageHandlers) {
                  // 不是ios真机
                  reject('获取app的类型 失败-reject')
                }
                window.getProductID = function (productID) {
                  resolve({
                    productID,
                    describe
                  })
                }
              })()
              break
            case 'Android':
              (() => {
                const productID = window.tikuWebview.getProductID()
                resolve({
                  productID,
                  describe
                })
              })()
              break
          }
        } catch (e) {
          reject('获取app的类型 失败-err')
          console.log(e, 'getAppType 获取app的类型')
        }
      })
    }
    // pdf分享
    setSharePdf (obj) {
      try {
        // 延迟一下 否则无效
        switch (this.terminalType) {
          case 'iOS':
            (() => {
              const shareParams = {
                type: 105,
                title: obj.title ? obj.title : '',
                data: obj.url
              }
              window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage(shareParams)
              return
            })()
            break
          case 'Android':
            (() => {
              window.tikuWebview.downloadShareMaterials(obj.url, obj.title)
            })()
            break
        }
      } catch (e) {
        console.log(e, '分享')
      }
    }
    // 强制返回首页
    goHome () {
      try {
        switch (this.terminalType) {
          case 'iOS':
            (() => {
              let data = {
                type: 106
              }
              window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage(data)
              return
            })()
            break
          case 'Android':
            (() => {
              window.tikuWebview.toHome()
            })()
            break
        }
      } catch (e) {
        console.log(e, '返回首页')
      }
    }
    // token过期，重新登录
    goLogin () {
      try {
        switch (this.terminalType) {
          case 'iOS':
            (() => {
              if (!window.webkit.messageHandlers) {
                // 不是ios真机
                reject('获取app的类型 失败-reject')
              }
              const iosObj = {
                type: 0
              }
              window.webkit.messageHandlers.HQKJJSBridgeiOSFunction.postMessage(iosObj)
              return
            })()
            break
          case 'Android':
            (() => {
              window.tikuWebview.toLogin()
            })()
            break
        }
      } catch (e) {
        console.log(e, '重新登录')
      }
    }
    // 保存图片
    saveImg (imgUrl) {
        try {
            switch (this.terminalType) {
              case 'iOS':
                (() => {
                  return
                })()
                break
              case 'Android':
                (() => {
                  window.tikuWebview.saveImg(imgUrl)
                })()
                break
            }
          } catch (e) {
            console.log(e, '重新登录')
          }
    }
  }
  export default new AppSdk()
  


// WEBPACK FOOTER //
// ./src/utils/appTool.js